module.exports = __webpack_public_path__ + "static/img/police-checker1.c04034c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checker/police-checker1.png
// module id = 14Lw
// module chunks = 1